const profiles = [
  {
    icon: "ri-bear-smile-line",
    title: "Crianças",
    range: "03 a 12 anos",
    desc: "Início promissor na carreira",
  },
  {
    icon: "ri-user-smile-line",
    title: "Adolescentes",
    range: "13 a 17 anos",
    desc: "Fase ideal para começar",
  },
  {
    icon: "ri-user-star-line",
    title: "Jovens",
    range: "18 a 25 anos",
    desc: "Auge para o mercado",
  },
  {
    icon: "ri-user-heart-line",
    title: "Adultos",
    range: "26 a 35 anos",
    desc: "Maturidade e presença",
  },
  {
    icon: "ri-camera-line",
    title: "Influencers",
    range: "Todas as idades",
    desc: "Potencial digital",
  },
];

export default function WhoCanParticipate() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-3 px-4" id="quem-pode">
            Quem Pode{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
              Participar
            </span>
          </h4>
          <p className="text-base sm:text-lg text-gray-600 max-w-xl mx-auto">
            Aberto para todos os perfis. Sem experiência necessária.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-5 mb-8">
          {profiles.map((p) => (
            <div
              key={p.title}
              className="bg-white rounded-2xl p-5 sm:p-6 hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-yellow-500 text-center group cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                <i className={`${p.icon} text-xl sm:text-2xl text-black`} />
              </div>
              <h3 className="text-base sm:text-lg font-bold text-black mb-1">{p.title}</h3>
              <p className="text-sm text-yellow-600 font-semibold mb-1">{p.range}</p>
              <p className="text-xs text-gray-500">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-black rounded-2xl p-5 sm:p-7 text-center">
          <p className="text-lg sm:text-xl text-white font-bold">
            <span className="text-yellow-500">Zero experiência?</span> Sem problema. Avaliamos seu potencial natural.
          </p>
        </div>
      </div>
    </section>
  );
}
